import styled from 'styled-components/macro';

export const GridContainer = styled.div`
  display: grid;
  grid-gap: 0 64px;
`;
